import BasePaymentController from 'app/src/controllers/payments/BasePaymentController';
import Localize from 'app/src/localize/Localize';
import GiftCardManager from 'app/src/payments/GiftCardManager';
import PaymentScanGiftCardView from 'app/src/views/payments/PaymentScanGiftCardView';
import Modules from 'shared_modules/Modules';

const _Events = {
  GIFT_CARD_SCAN_COMPLETE: 'gift:card:scan:complete',
};

export default class PaymentScanGiftCardViewController extends BasePaymentController {
  static get Event() {
    return _Events;
  }

  /**
   * Constructor for a PaymentScanGiftCardViewController
   *
   * @param saleManager {SaleManager} The sale manager associated with the sale
   */
  constructor(saleManager, options = {}) {
    super(saleManager);

    this._options = options;

    // initialize the controller's managed view
    this.view = new PaymentScanGiftCardView();
  }

  /**
   * Sets the initial state of dynamic data within the view.
   */
  setInitialViewState() {
    // Focus the cursor on the Gift Card Input field
    this.view.setFocusOnGiftCardInput();
  }

  /**
   * Event handler for when the user has requested to scan (lookup) a gift card.
   *
   * @param cardNumber {string}   The gift card number
   */
  onSubmitGiftCardRequested(cardNumber) {
    if (GiftCardManager.isValidCardNumber(cardNumber)) {
      GiftCardManager.fetchGiftCardDetails(cardNumber)
        .done(giftCardModel => {
          if (giftCardModel.get('archived') === true) {
            // Show the disabled message
            let message = Localize.translate(
              `Gift <var>${giftCardModel.get('code')}</var> has been disabled.` +
                " <a href='/register.php?form_name=view&name=credit_account.views.gift_card&id=" +
                `${giftCardModel.id}'>View gift card record</a>.`
            );
            flashNotifier('messages', message, 15);
          } else {
            // we always allow refunding a gift card no matter what the available balance
            if (
              this._saleManager.isRefundSale() ||
              giftCardModel.availableCreditBalance.isGreaterThan(0)
            ) {
              this.trigger(_Events.GIFT_CARD_SCAN_COMPLETE, giftCardModel, this._options);
            } else {
              alertUser(Localize.translate('Gift card is empty.'));
            }
          }
        })
        .fail(() => {
          if (this._saleManager.isRefundSale()) {
            // we automatically create a gift card when one doesn't exist for refunds
            GiftCardManager.createGiftCard(
              cardNumber,
              this._saleManager.customer ? this._saleManager.customer.get('customerID') : null
            ).done(giftCardModel => {
              this.trigger(_Events.GIFT_CARD_SCAN_COMPLETE, giftCardModel, this._options);
            });
          } else {
            alertUser(Localize.translate('No gift card found.'));
          }
        });
    } else {
      alertUser(Localize.translate('Scan was not a gift card.'));
    }
  }
}
